export const IS_USER_SET_COOKIE_SETTINGS = 'is_user_set_cookie_settings' as const;
export const ANALYTICS_COOKIE_PERMISSION_KEY = 'is_analytics_cookie_allowed' as const;
export const MARKETING_COOKIE_PERMISSION_KEY = 'is_marketing_cookie_allowed' as const;
